import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../navbar/navbar';
import styled from 'styled-components';
import Swal from 'sweetalert2';

const Settings = () => {
  const navigate = useNavigate();
  const [prevPassword, setPrevPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [showPrevPassword, setShowPrevPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [waiting, setWaiting] = useState(false);
  const userImage=parseInt(sessionStorage.getItem("icon"), 10);
  const [newAvatar, setNewAvatar] = useState(userImage);
  const [updatingAvatar, setUpdatingAvatar] = useState(false);
  
  const serverHost = process.env.REACT_APP_SERVER_HOST
  
  useEffect(() => {
    const handleAuth = () => {
      if (sessionStorage.getItem("user_id") === null) {
        console.log("Not Authenticated");
        navigate('/');
      }
    };

    handleAuth();
  }, [navigate]);

  const togglePasswordVisibility = (setter) => {
    setter((prevValue) => !prevValue);
  };

  const handleAvatarChange = async (event) => {
    event.preventDefault();
    setUpdatingAvatar(true);
    
    if (newAvatar === userImage) {
      Swal.fire({
        title: 'Failed to update Avatar',
        text: 'This Avatar is already selected, Nothing to change.',
        icon: 'error',
        confirmButtonText: 'Close'
      });
      setUpdatingAvatar(false);
      return;
    }

    const formData = new FormData();

    formData.append('uid', parseInt(sessionStorage.getItem("user_id"), 10));
    formData.append('icon', newAvatar);

    try {
      const response = await fetch(`${serverHost}/update-avatar`, {
        method: 'POST',
        body: formData
      });

      const result = await response.json();

      if (response.status === 200) {
        Swal.fire({
          title: 'Avatar Updated',
          text: 'Your avatar has been successfully updated.',
          icon: 'success',
          confirmButtonText: 'Close'
        });
        sessionStorage.setItem('icon', result.icon);
        setUpdatingAvatar(false);
      } else {
        Swal.fire({
          title: 'Failed to update Avatar',
          text: result.error,
          icon: 'error',
          confirmButtonText: 'Close'
        });
      }
    } catch (error) {
      Swal.fire({
        title: 'Failed to update Avatar',
        text: error,
        icon: 'error',
        confirmButtonText: 'Close'
      });
    }
    setUpdatingAvatar(false);
  }

  const changePassword = async (event) => {
    event.preventDefault();
    setWaiting(true);

    const formData = new FormData();

    formData.append('uid', parseInt(sessionStorage.getItem("user_id"), 10));

    if (newPassword.length < 6) {
      Swal.fire({
        title: 'Failed to update password',
        text: 'Password should be atleast 6 characters long',
        icon: 'error',
        confirmButtonText: 'Close',
      });
      setWaiting(false);
      return;
    }

    formData.append('prevPassword', prevPassword);
    formData.append('newPassword', newPassword);
    
    try {
      const response = await fetch(`${serverHost}/update-password`, {
        method: 'POST',
        body: formData,
      });
      const result = await response.json();

      if (response.status === 200) {
        Swal.fire({
          title: 'Password Updated',
          text: 'Your password has been successfully updated.',
          icon: 'success',
          confirmButtonText: 'Close',
        });
        setWaiting(false);
      } else {
        Swal.fire({
          title: 'Failed to update password',
          text: result.error,
          icon: 'error',
          confirmButtonText: 'Close',
        });
      }
    } catch (error) {
      Swal.fire({
        title: 'Failed to update password',
        text: error,
        icon: 'error',
        confirmButtonText: 'Close'
      });
    } finally {
      setWaiting(false);
    }
  };

  return (
    <>
      <Navbar />
      <Container>
        <ProfileSection>
          <Label>
            <span>
              Welcome <b>{sessionStorage.getItem("username")}</b> 👋
            </span>
          </Label>
          <ProfilePic>
            <p>Choose your avatar</p>
            <AvatarPicker>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
                <img src={`avatars/${ (newAvatar > 1) ? newAvatar-1 :  8 }.png`} alt="prev avatar" />
                <img style={{ width: '120px' }} src={`avatars/${newAvatar}.png`} alt="current avatar" />
                <img src={`avatars/${ (newAvatar < 8) ? newAvatar+1 : 1 }.png`} alt="next avatar" />
              </div>
              <div style={{ marginTop: '20px', display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
                <i className='fa fa-arrow-left' style={{ color: 'grey', pointerEvents: updatingAvatar ? 'none' : 'auto' }} onClick={() => setNewAvatar((newAvatar > 1) ? newAvatar-1 :  8)} />
                <i className='fa fa-check' style={{ color: 'white', background: 'green', borderRadius: '50%', padding: '5px', cursor: 'pointer', pointerEvents: updatingAvatar ? 'none' : 'auto' }} onClick={handleAvatarChange} />
                <i className='fa fa-arrow-right' style={{ color: 'grey', pointerEvents: updatingAvatar ? 'none' : 'auto' }} onClick={() => setNewAvatar((newAvatar < 8) ? newAvatar+1 : 1) } />
              </div>
            </AvatarPicker>
          </ProfilePic>
          <Form id="changePassword" onSubmit={changePassword}>
            <p>Change your password</p>
            <PasswordInputContainer>
              <PasswordInput
                type={showPrevPassword ? 'text' : 'password'}
                required
                value={prevPassword}
                autoComplete="off"
                onChange={(e) => setPrevPassword(e.target.value)}
                placeholder="Current Password"
              />
              <VisibilityButton
                onClick={() => togglePasswordVisibility(setShowPrevPassword)}
              >
                {showPrevPassword ? 'Hide' : 'Show'}
              </VisibilityButton>
            </PasswordInputContainer>
            <PasswordInputContainer>
              <PasswordInput
                type={showNewPassword ? 'text' : 'password'}
                required
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                autoComplete="off"
                placeholder="New Password"
              />
              <VisibilityButton
                onClick={() => togglePasswordVisibility(setShowNewPassword)}
              >
                {showNewPassword ? 'Hide' : 'Show'}
              </VisibilityButton>
            </PasswordInputContainer>
            <ChangePasswordButton onClick={changePassword} disabled={waiting}>{waiting ? <i className='fa fa-spinner' /> : 'Change Password'}</ChangePasswordButton>
          </Form>
        </ProfileSection>
      </Container>
    </>
  );
};

export default Settings;

const Container = styled.main`
  display: flex;
  align-items: center;
  height: 86vh;
  background-color: white;
  justify-content: space-around;
`;

const ProfileSection = styled.div`
  height: auto;
  width: 25vw;
  border-radius: 5px;
  background: rgba(217, 217, 217, 0.5);
  box-shadow: rgba(0, 0, 0, 0.2) -5px 5px 0px;

  button {
    background-color: #6559a2;
    padding: 10px 25px;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
  }

  @media only screen and (max-width: 600px) {
    width: 90vw;
  }
`;

const Label = styled.div`
  text-align: center;
  margin-top: 20px;

  span {
    font-size: 26px;
    color: #6559a2;
  }
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  margin: 20px 0;
  padding: 0 20px;
`;

const PasswordInputContainer = styled.div`
  position: relative;

  span {
    font-size: 14px;
    font-weight: bold;
    position: absolute;
    top: 25%;
    right: 10px;
    color: #6559a2;
    cursor: pointer;
  }
`;

const PasswordInput = styled.input`
  padding: 10px;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-bottom: 10px;
  padding-right: 50px !important;
`;

const ProfilePic = styled.div`
  margin: 20px 0;
  padding: 0 20px;
`;

const VisibilityButton = styled.span`
  font-size: 14px;
  font-weight: bold;
  position: absolute;
  top: 25%;
  right: 10px;
  color: #6559a2;
  cursor: pointer;
`;

const ChangePasswordButton = styled.button`
  background-color: #6559a2;
  padding: 10px 25px;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  box-shadow: rgba(0, 0, 0, 0.2) -3px 3px 0px;
`;

const AvatarPicker = styled.div`
  img {
    border-radius: 50%;
  }
`;